import { EditYourFoodRequest } from "@/clients/models/EditYourFoodRequest";
import SelectWithLabel from "@/components/form/hook-form/select-with-label";
import { memo } from "react";
import { Control, FieldValues, Path } from "react-hook-form";

/** Meal time options shared by Add Recipe and Edit Recipe forms (same enum values). */
const MEAL_TIME_OPTIONS = [
  { value: EditYourFoodRequest.meal_time.BREAKFAST, name: "Breakfast" },
  { value: EditYourFoodRequest.meal_time.LUNCH, name: "Lunch" },
  { value: EditYourFoodRequest.meal_time.DINNER, name: "Dinner" },
  { value: EditYourFoodRequest.meal_time.SNACK, name: "Snack" },
] as const;

/** Form shape expected by MealTimeSelect: must have a mealTime field. */
type FormWithMealTime = FieldValues & { mealTime: string };

interface MealTimeSelectProps<T extends FormWithMealTime> {
  control: Control<T>;
}

/**
 * Meal time select field for recipe forms (Add Recipe and Edit Recipe).
 * Renders a labelled select with Breakfast / Lunch / Dinner / Snack options.
 */
export const MealTimeSelect = memo(function MealTimeSelect<T extends FormWithMealTime>({
  control,
}: MealTimeSelectProps<T>) {
  return (
    <SelectWithLabel
      control={control}
      name={"mealTime" as Path<T> & "mealTime"}
      label="Meal time"
      placeholder="Select..."
      options={MEAL_TIME_OPTIONS.map((o) => ({ value: o.value, name: o.name }))}
      selectTitle="Select meal as..."
    />
  );
}) as <T extends FormWithMealTime>(props: MealTimeSelectProps<T>) => JSX.Element;
